import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { AnyPtrRecord } from 'dns';
import { arrayRemove } from 'firebase/firestore';
import { Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class FirestoreService {
  
  constructor(private firestore: AngularFirestore,
              private storage: AngularFireStorage) { }

crearDato(path: string, dato: any): Promise<any> {
  return this.firestore.collection(path).add(dato);
}
  
  traerBusqueda(path: string, correo: string): Observable<any> {
    return this.firestore.collection(path, ref => ref.where('correo', '==', correo).limit(5)).snapshotChanges();
  }

  traerBusquedaUsuario(path: string, cliente: string): Observable<any> {
    return this.firestore.collection(path, ref => ref.where('cliente', '==', cliente).limit(5)).snapshotChanges();
  }
  traerYoutube(path: string): Observable<any> {
    const nowinicio = new Date()
    nowinicio.setDate(nowinicio.getDate()-160)
     function padTo2Digits(num) {
       return num.toString().padStart(2, '0');
     }
     function formatDate(date) {
       return (
         [
           date.getFullYear(),
           padTo2Digits(date.getUTCMonth()+1),
           padTo2Digits(date.getUTCDate())
         ].join('-')
       );
     }
     const nowfin = new Date()
     nowfin.setDate(nowfin.getDate()-2)
     function padTo2Digits2(num) {
       return num.toString().padStart(2, '0');
     }
     function formatDate2(date) {
       return (
         [
           date.getFullYear(),
           padTo2Digits2(date.getUTCMonth()+1),
           padTo2Digits2(date.getUTCDate())
         ].join('-')
       );
     }
     let fin=formatDate2(nowfin)
     //console.log('nowfin',fin)

     let inicio=formatDate(nowinicio)
     let inicio2 = new Date(inicio)
     //console.log('inicio',inicio)
    return this.firestore.collection(path, ref => ref.where('servicio', 'in', ['youtube','youtube1','youtube2','youtube3']).orderBy('fechaventa', 'desc').endAt(inicio2)).snapshotChanges();
  }

  traerSpotify(path: string): Observable<any> {
    const nowinicio = new Date()
    nowinicio.setDate(nowinicio.getDate()-160)
     function padTo2Digits(num) {
       return num.toString().padStart(2, '0');
     }
     function formatDate(date) {
       return (
         [
           date.getFullYear(),
           padTo2Digits(date.getUTCMonth()+1),
           padTo2Digits(date.getUTCDate())
         ].join('-')
       );
     }
     const nowfin = new Date()
     nowfin.setDate(nowfin.getDate()-2)
     function padTo2Digits2(num) {
       return num.toString().padStart(2, '0');
     }
     function formatDate2(date) {
       return (
         [
           date.getFullYear(),
           padTo2Digits2(date.getUTCMonth()+1),
           padTo2Digits2(date.getUTCDate())
         ].join('-')
       );
     }
     let fin=formatDate2(nowfin)
     //console.log('nowfin',fin)

     let inicio=formatDate(nowinicio)
     let inicio2 = new Date(inicio)
    // console.log('inicio',inicio)
    return this.firestore.collection(path, ref => ref.where('servicio', 'in', ['spotify','spotify1','spotify2']).orderBy('fechaventa', 'desc').endAt(inicio2)).snapshotChanges();
  }


  traerDatos(path: string): Observable<any> {
    return this.firestore.collection(path).snapshotChanges();
  }
  traerRenovaciones(user: string): Observable<any> {
    return this.firestore.collection('users').doc(user).collection('renovar',ref => ref.orderBy('estado')).snapshotChanges();
  }

  traerVentasMes(path: string): Observable<any> {
    const now = new Date()
    now.setDate(now.getDate()-31)
     function padTo2Digits(num) {
       return num.toString().padStart(2, '0');
     }
     function formatDate(date) {
       return (
         [
           date.getFullYear(),
           padTo2Digits(date.getUTCMonth()+1),
           padTo2Digits(date.getUTCDate())
         ].join('-')
       );
     }
     let formatenow=formatDate(now)
   //  console.log('formatenow',formatenow)
    return this.firestore.collection(path, ref => ref.orderBy('fechaventaadmin', 'asc').startAt(formatenow)).get();
  }

  traerCombos(path: string): Observable<any> {
    return this.firestore.collection(path, ref => ref.where('preciocombo','>', 0)).snapshotChanges();
  }
  traerDatosGarantias(path: string): Observable<any> {
    const now = new Date()
    now.setDate(now.getDate()-30)

     //console.log('formatenow',now)
    return this.firestore.collection(path, ref => ref.orderBy('fecha', 'desc').endAt(now)).snapshotChanges();
  }
  traerDatosGrupGarantias(path){
    return this.firestore.collectionGroup(path).snapshotChanges();
  }

  traerDatosFecha(path: string): Observable<any> {
    return this.firestore.collection(path, ref => ref.orderBy('fecha', 'desc')).snapshotChanges();
  }
  traerDatosVentas(path: string): Observable<any> {
    return this.firestore.collection(path, ref => ref.orderBy('fechaventa', 'desc').limit(20)).snapshotChanges();
  }

  traerDato(path: string, id: string,): Observable<any> {
    return this.firestore.collection(path).doc(id).get();
  }
  eliminarDato(path: string, id: string): Promise<any> { 
    return this.firestore.collection(path).doc(id).delete();
  }
  actualizarDato(path: string, id: string, data: any): Promise<any> {
    return this.firestore.collection(path).doc(id).update(data);
  }
  renovar(user:any,data:any){
  //  console.log('user=>',user,'data=>', data)
    const collectionUser = this.firestore.collection('users').doc(user.uid).collection('ventas').doc();
    const collectionTotalVentas = this.firestore.collection('totalventas').doc(collectionUser.ref.id);
    const collectionUserRenovar = this.firestore.collection('users').doc(user.uid).collection('renovar').doc(data.idRenovacion);
    const batch = this.firestore.firestore.batch()
    
    batch.set(collectionUser.ref,data)
   
    batch.set(collectionTotalVentas.ref,data)
  
    batch.update(collectionUserRenovar.ref,{'estado': 'entregada'}) 
    
    return batch.commit()
  }

  async uploadImage(file: any, path: string, nombre: string): Promise<string> {
    const ref = this.storage.ref(path + '/' + nombre);
  
    const snapshot = await ref.put(file);          // se rechaza si la subida falla
    return await snapshot.ref.getDownloadURL();    // devuelve la URL
  }

  traerVentasMesStatistics(user:string, primerdia:any,ultimoDia:any){
    return this.firestore.firestore.collection('users').doc(user).collection('ventas').where('fechaventa', '>', primerdia).where('fechaventa', '<', ultimoDia).get()
  }
  async crearStatisticsMes(user: string,mes:any, dato: any): Promise<any> {
    let validador
    let collectionUserStatistics = this.firestore.firestore.collection('users').doc(user).collection('estadisticas').doc(mes)
    validador = (await collectionUserStatistics.get()).exists

    if(validador){
      return collectionUserStatistics.get()
      
    }else{
      return  this.firestore.collection('users').doc(user).collection('estadisticas').doc(mes).set(dato).then(async () => {
        return this.firestore.firestore.waitForPendingWrites().then(async res =>{
          return collectionUserStatistics.get()
        });
      })
      .catch(err => {
       // console.log('error', err);
        return err
      });
  
    }
    
  }

  validarMes(user:string, mes:string){
    const validador = this.firestore.firestore.collection('users').doc(user).collection('estadisticas').doc(mes).get()
  }
  traerMesActual(path: string, id: string,): Observable<any> {
    return this.firestore.collection(path).doc(id).snapshotChanges();
  }

  actualizarDatoCedula(path: string, id: string, data: any): Promise<any> {
    return this.firestore.collection(path).doc(id).set(data, { merge: true });
  }

  openContabilidadCedulas(): Observable<any[]> {
    return this.firestore
      .collection('sliders')
      .doc('NDCpTZkVh0tvUWUa4K4V')
      .get()
      .pipe(
        map((doc) => {
          if (doc.exists) {
            const data = doc.data() as { contabilidad?: any[] };
            return data.contabilidad || []; // Devolver los datos
          } else {
            console.log('El documento no existe');
            return [];
          }
        })
      );
  }
  

  
}